import overrideStyle from 'lib/overrideStyle';
import getRadius from 'lib/getRadius';

const CollectionField = overrideStyle('div')`
  background-color: white;
  border-radius: ${p => getRadius(p.theme.borderRadius, 2, 4)};
  border: ${p => (p.shouldShowError ? '1px solid red' : '1px solid white')};
  height: 40px;
  margin: 24px 32px 24px 32px;
  padding: 8px 12px 0px 12px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  }
`;

const CollectionFieldCVV = overrideStyle(CollectionField)`
  margin: 0px 0px 0px 8px;
  width: 60%;
`;

const CollectionFieldEXP = overrideStyle(CollectionField)`
  margin: 0px 8px 0px 0px;
  width: 40%;
`;

const CollectionFieldLabel = overrideStyle('div')`
  color: #767676;
  font-size: 10px;
  font-weight: 500;
`;

export default {
  CollectionField,
  CollectionFieldCVV,
  CollectionFieldEXP,
  CollectionFieldLabel,
};
